module.exports = __webpack_public_path__ + "c7802339237c469002a82772312c4c37.MP3";